/**
 * The blind round: in a one-card round you hold your card facing outward, so
 * everyone sees everybody else's card and nobody sees their own.
 *
 * This predicate lives in the shared engine because two places must agree on it
 * exactly. The server uses it to decide which hands to redact; the client uses it
 * to decide what to draw. If the two ever disagreed the result would be either a
 * leaked card or an unplayable screen, so there is one function and no second
 * copy of the condition.
 */

import type { HouseRules } from '@shared/types/game';
import type { LivePhase } from '@shared/types/live';

export interface BlindRoundInput {
  cards: number;
  phase: LivePhase;
  houseRules: HouseRules;
}

export function isBlindRound({ cards, phase, houseRules }: BlindRoundInput): boolean {
  if (!houseRules.blindSingleCardRound) return false;
  if (cards !== 1) return false;
  // Once the trick is played the round is over: scoring and the final standings
  // are public, and by then every hand is empty anyway.
  return phase === 'bidding' || phase === 'playing';
}
